import script from "./AssetInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./AssetInfo.vue?vue&type=script&setup=true&lang=js"

import "./AssetInfo.vue?vue&type=style&index=0&id=3d7d8663&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7d8663"]])

export default __exports__